import axios, { AxiosResponse } from 'axios';

import { EHlasovani } from 'enums/akcionarKorpAkce/hlasovani';
import { EStavHl } from 'enums/akcionarKorpAkce/stavHl';
import { ETypUdalosti } from 'enums/akcionarKorpAkce/typUdalosti';
import { EVotetp } from 'enums/akcionarKorpAkce/votetp';

export const hromadneHlasovaniZalozeni = (id: string | number) => {
    return axios({
        method: 'POST',
        url: `/Spravceuctu/${id}/Zalozithrom`
    }).then(
        (
            resp: AxiosResponse<{
                idhrom: number;
            }>
        ) => resp.data
    );
};

export interface IHromadneHlasovaniUctyInput {
    order?: string;
    limit?: number;
    offset?: number;
    vybran?: boolean;
    cdac?: string;
    rcma?: string;
    nazev?: string;
    stav?: string;
    vse?: boolean;
}

export interface IHromadneHlasovaniUcty {
    count: number;
    order: string;
    limit: number;
    offset: number;
    uctyudalosti: {
        oid: number;
        vybran: boolean;
        cdac: string;
        rcma: string;
        nazev: string;
        pocet: number;
        stavhl: EStavHl;
        max: number;
    }[];
}

export const hromadneHlasovaniUcetVybrat = (idhrom: string | number, oid: string | number, vybran: boolean) => {
    return axios({
        method: 'PUT',
        url: `/Hlasovani/${idhrom}/Ucty/Vybrat/${oid}`,
        data: {
            vybran: vybran
        }
    }).then((resp: AxiosResponse<IHromadneHlasovaniUcty>) => resp.data);
};

export const hromadneHlasovaniUctyVSE = (
    idhrom: string | number,
    vse: boolean,
    filterData: IHromadneHlasovaniUctyInput
) => {
    return axios({
        method: 'PUT',
        url: `/Hlasovani/${idhrom}/Ucty/Vybratvse`,
        params: filterData,
        data: {
            vybran: vse
        }
    }).then((resp: AxiosResponse<IHromadneHlasovaniUcty>) => resp.data);
};

export const hromadneHlasovaniUctyGET = (idhrom: string | number, data: IHromadneHlasovaniUctyInput) => {
    return axios({
        method: 'GET',
        url: `/Hlasovani/${idhrom}/Ucty`,
        params: data
    }).then((resp: AxiosResponse<IHromadneHlasovaniUcty>) => resp.data);
};

export interface IHlasovaniHromadne {
    issrlabl: string;
    typhlasu: EHlasovani;
}

export interface IHlasovaniHromadneBody {
    issrlabl: string;
    titl: string;
    desc: string;
    forinfonly: true;
    votetp: EVotetp;
    urladdress: string;
    hlasovani: { hlasovani: EHlasovani }[];
}
export interface IHromadneHlasovaniData {
    id: number;
    isin: string;
    nazevemise: string;
    datumkonani: string;
    rozhodnyden: string;
    typudalosti: ETypUdalosti;
    vh: {
        reqid: string;
        emitent: string;
        termin: string;
        bodyvh: IHlasovaniHromadneBody[];
    };
    hlasovani: {
        sezhlasovani: IHlasovaniHromadne[];
    };
}

export const hromadneHlasovaniGET = (idhrom: string | number) => {
    return axios({
        method: 'GET',
        url: `/Hlasovani/${idhrom}`
    }).then((resp: AxiosResponse<IHromadneHlasovaniData>) => resp.data);
};
export const hromadneHlasovaniPocetPut = (idhrom: string | number, oid: string | number, pocet: string | number) => {
    return axios({
        method: 'PUT',
        url: `/Hlasovani/${idhrom}/Ucty/Pocet/${oid}`,
        data: {
            pocet: pocet
        }
    });
};

export interface IHromadneHlasovaniPut {
    sezhlasovani: IHlasovaniHromadne[];
}

export const hromadneHlasovaniZapsatPut = (idhrom: string | number, data: IHromadneHlasovaniPut) => {
    return axios({
        method: 'PUT',
        url: `/Hlasovani/${idhrom}`,
        data: data
    });
};
